<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Temperature comfort zone usage" chart.
    </rb-callout>
</div>
<div id="temp-comfort-zone-chart-ef"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container">
        Distribution of the frequency of occurrence of the operation time spent in different temperature regimes for the fleet and for each selected vehicle. Green colors correspond to the comfort temperature zone while red and blue represent unfavorable edge conditions.
</div>